import { InitialStateInterface, ActionInterface } from './interface';

const initialState: InitialStateInterface = {
  loginError: '',
  usernameError: '',
  passwordError: '',
  loginInProgress: false,
};

const loginReducer = (
  state: InitialStateInterface,
  action: ActionInterface,
) => {
  switch (action.type) {
    case 'login':
      return { ...state, ...action.payload };
    case 'loginError':
      return { ...state, ...action.payload };
    default:
      return state;
  }
};

export { loginReducer, initialState };
